export function videoEmbed() {
    document.querySelectorAll('[data-video-embed]').forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const videoEmbedCode = button.dataset.videoEmbed;
            const placeholder = button.parentElement.querySelector('[data-video-placeholder]');

            if (!videoEmbedCode || !placeholder) {
                return;
            }

            placeholder.innerHTML = videoEmbedCode;
            button.remove();
        });
    });
}
